import { createFileRoute } from '@tanstack/react-router';
import { useTranslation } from 'react-i18next';
import { EditorPage } from '@/features/editor/editor-page';
import { ConsoleShell } from '@/features/shell/console-shell';
import { EntityName } from '@/features/references/entity-ref';

/**
 * Éditeur bas-code, acte 3 : `docs/porting/vague-1/editeur-bas-code.md`.
 * Route `/draw/:resourceType/:drawMode/:graphId` en legacy — les trois segments servaient à
 * router les messages de l'iframe. Sans iframe, seul l'identifiant du graphe reste utile.
 */
export const Route = createFileRoute('/$tenant/editor/$graphId')({ component: EditorRoute });

function EditorRoute() {
  const { tenant, graphId } = Route.useParams();
  const { t } = useTranslation();
  return (
    <ConsoleShell
      tenantId={tenant}
      activeItem="editor"
      crumbs={[
        { label: t('nav.items.editor') },
        { label: <EntityName tenantId={tenant} kind="graph" id={graphId} /> },
      ]}
    >
      <EditorPage tenantId={tenant} graphId={graphId} />
    </ConsoleShell>
  );
}
